import React from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import EconomicActivityTypesCRUD from './EconomicActivityTypes';

const ExpenseCategory = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title='Listado' pageTitle='Tipos de Actividad Economica' />
                <EconomicActivityTypesCRUD />
            </div>
        </React.Fragment>
    )
}

export default ExpenseCategory;